export const transformAttachments = (attachments) => {
    const transformedAttachments = attachments.map((attachment) => {
        if (!attachment.isDeleted) {
            return {
                source: attachment.storageKey,
                options: {
                    type: "local",
                    file: {
                        id: attachment._id,
                        name: attachment.name,
                        size: attachment.size,
                        type: attachment.mimeType,
                    },
                },
            };
        }
        return null;
    });
    return transformedAttachments.filter((attachment) => attachment !== null);
};

export const restoreAttachments = (attachments, currentAttachments = []) => {
    const attachmentSources = new Set(attachments.filter((attachment) => attachment.source).map((attachment) => attachment.source));
    const result = [];

    // Add deleted attachments (those in currentAttachments but not in attachments)
    for (const currentAttachment of currentAttachments) {
        if (currentAttachment.source && !attachmentSources.has(currentAttachment.source)) {
            const file = currentAttachment.options.file;
            result.push({
                filename: file.name,
                size: file.size,
                mimetype: file.type,
                storageKey: currentAttachment.source,
                id: file.id || "",
                isDeleted: true,
            });
        }
    }

    // Add restored attachments
    for (const attachment of attachments) {
        
        let serverId;
        try {
            serverId = JSON.parse(attachment.serverId).id;
        } catch {
            serverId = attachment.serverId;
        }

        let file;
        try {
            file = attachment.file.toObject();
        } catch {
            file = attachment.file;
        }

        if (file) {
            result.push({
                filename: file.name,
                size: file.size,
                mimetype: file.type,
                storageKey: serverId,
                id: file.id || "",
                isDeleted: attachment.isDeleted || false,
            });
        }
    }

    return result;
};

const RASTER_IMAGE_TYPES = new Set(['image/png', 'image/jpeg', 'image/jpg', 'image/pjpeg', 'image/gif', 'image/webp', 'image/avif', 'image/bmp', 'image/x-icon', 'image/vnd.microsoft.icon']);

// Blob URLs run on the app origin, so only raster types may become one.
export const isRasterImage = (mimeType) => typeof mimeType === 'string' && RASTER_IMAGE_TYPES.has(mimeType.split(';')[0].trim().toLowerCase());
